/* Shared assessment rules used by the browser and lead service.
 * Legacy answer key over64 is retained for transport compatibility; current label means over 6 feet 6 inches.
 */
globalThis.FcpFit = (() => {
  const questions=[
  {
    "key": "use",
    "title": "Is this for personal or commercial use?",
    "options": {
      "home": "Personal use",
      "commercial": "Commercial use"
    }
  },
  {
    "key": "business_type",
    "title": "What type of business?",
    "branch": "commercial",
    "options": {
      "rental": "Short-term rental",
      "gym": "Gym",
      "wellness": "Wellness or recovery center",
      "contrast": "Contrast therapy studio",
      "other": "Other"
    }
  },
  {
    "key": "business_other",
    "title": "What type of business?",
    "branch": "other_business",
    "type": "text"
  },
  {
    "key": "placement",
    "title": "Where will your cold plunge live?",
    "options": {
      "indoor": "Indoors",
      "outdoor": "Outdoors",
      "unsure": "Not sure yet"
    }
  },
  {
    "key": "cover",
    "title": "Will it be covered?",
    "branch": "outdoor",
    "options": {
      "covered": "Fully covered",
      "partial": "Partially covered",
      "uncovered": "Completely uncovered"
    }
  },
  {
    "key": "location",
    "title": "Where indoors?",
    "branch": "indoor",
    "options": {
      "main": "Main floor",
      "garage": "Garage",
      "basement": "Basement",
      "upper": "Upper floor",
      "other": "Other indoor location"
    }
  },
  {
    "key": "stairs",
    "title": "Will it need to go up or down stairs?",
    "branch": "indoor",
    "options": {
      "yes": "Yes",
      "no": "No"
    }
  },
  {
    "key": "climate_cold",
    "title": "What's the coldest it gets where you live?",
    "optional": true,
    "options": {
      "belowminus20": "Below -20°F",
      "minus20_0": "-20°F to 0°F",
      "above0_32": "1°F to 32°F",
      "above32": "Above 32°F",
      "unsure": "Not sure"
    }
  },
  {
    "key": "climate_hot",
    "title": "What's the hottest it gets where you live?",
    "optional": true,
    "options": {
      "under90": "Below 90°F",
      "b90_110": "90°F to 110°F",
      "b111_120": "111°F to 120°F",
      "over120": "Above 120°F",
      "unsure": "Not sure"
    }
  },
  {
    "key": "priority",
    "title": "What concerns you most?",
    "options": {
      "reliability": "Reliable equipment",
      "yearround": "Year round outdoor use",
      "leaks": "Leaks",
      "support": "Poor support",
      "price": "Price",
      "space": "Space constraints",
      "aesthetics": "Aesthetics",
      "other": "Other"
    }
  },
  {
    "key": "priority_other",
    "title": "What concerns you most?",
    "branch": "other_concern",
    "type": "text"
  },
  {
    "key": "height",
    "title": "What is your height?",
    "options": {
      "under52": "Under 5'2\"",
      "between": "Between 5'2\" and 6'6\"",
      "over64": "Over 6'6\""
    }
  },
  {
    "key": "weight",
    "title": "What is your weight?",
    "options": {
      "under150": "Under 150 lbs",
      "w150_199": "150–199 lbs",
      "w200_249": "200–249 lbs",
      "over250": "250+ lbs"
    }
  },
  {
    "key": "temperature",
    "title": "What's the coldest you'll ever put your water?",
    "options": {
      "t50": "50°F",
      "t40": "40°F",
      "t32": "32°F",
      "unsure": "Not sure"
    }
  },
  {
    "key": "support",
    "title": "How important is live U.S.-based support?",
    "options": {
      "1": "1",
      "2": "2",
      "3": "3",
      "4": "4",
      "5": "5",
      "6": "6",
      "7": "7",
      "8": "8",
      "9": "9",
      "10": "10"
    }
  },
  {
    "key": "budget",
    "title": "What is your cold plunge budget?",
    "options": {
      "under3000": "Under $3,000",
      "b3000_4994": "$3,000–$4,994",
      "b4995_6999": "$4,995–$6,999",
      "over7000": "$7,000 or more",
      "unsure": "Still deciding"
    }
  }
];
  const active = a => questions.filter(q=>!q.branch || q.branch===a.placement || (q.branch==='commercial'&&a.use==='commercial') || (q.branch==='other_business'&&a.use==='commercial'&&a.business_type==='other') || (q.branch==='other_concern'&&a.priority==='other'));
  const clean = a => Object.fromEntries(active(a).filter(q=>a[q.key]!==undefined).map(q=>[q.key,a[q.key]]));
  const label = (key,value) => questions.find(q=>q.key===key)?.options?.[value] || value;
  function assess(raw) {
    const a=clean(raw),summary=[],commercial=a.use==='commercial',low=['under3000','b3000_4994'].includes(a.budget),climateOutside=a.placement!=='indoor'&&(a.climate_cold==='belowminus20'||a.climate_hot==='over120');
    const supportCopy=Number(a.support)>5?'Live support matters to you. We always answer during business hours, and you’ll speak with a real person in the U.S. Put us to the test. Call us and hear for yourself. After hours, we call you back within one business day.':Number(a.support)<5?'Even if phone support isn’t your top priority, it matters when something goes wrong. Our U.S.-based team answers the phone, so you can get help when you need it. After-hours messages get a callback within one business day.':'You want support available when you need it. Real people in the U.S. answer our phone, and after-hours messages get a callback within one business day.';
    const budgetCopy=commercial?'Call our commercial team for pricing.':low?'The residential model starts at $4,995, above your stated budget. Call us for specials and promotions. Ask whether we have scratch-and-dent units available.':'The residential model starts at $4,995. Your budget puts you in reach of built-in cooling down to 32°F with ice-making capability, an ergonomic liner, a hard-top gasket-sealed lid, year-round outdoor use without winterization, and live U.S.-based phone support.';
    const concern={
      reliability:'Our plunge keeps the cooling system built into the plunge. If you need help, real people in the U.S. answer the phone and help you get back to plunging.',
      yearround:climateOutside?'Your climate falls outside our -20°F to 120°F outdoor operating range. Call us before ordering to discuss whether your location is suitable.':'Our plunge runs outdoors year-round without seasonal winterization, in outdoor temperatures from -20°F to 120°F.',
      leaks:commercial?'The cooling system is built into the plunge, with no external chiller hoses.':'Our residential plunge is leak-free by design. Its internal liner is one seamless piece with no holes in the tub.',
      support:supportCopy,
      price:budgetCopy,
      space:'The cooling system is built into our plunge, so you don’t need space for a separate chiller. Measure the space for the tub and the path to get it there.',
      aesthetics:'The tub and cooling system are integrated. No separate chiller or connecting hoses beside your plunge.',
      other:'You wrote: “'+(a.priority_other||'')+'”. Call us with that question. You’ll speak with a real person in the U.S.'
    };
    if(a.priority==='other'){
      const text=(a.priority_other||'').toLowerCase();
      const topics=[['leaks',/leak|water damage|flood/],['yearround',/winter|freez|outdoor|weather/],['support',/support|service|help|warranty/],['price',/price|budget|cost|expensive|discount|promotion/],['space',/space|dimension|width|door|size|fit through/],['aesthetics',/look|design|aesthetic|appearance/],['reliability',/reliab|break|durab|last|equipment/]];
      const match=topics.find(([,pattern])=>pattern.test(text));
      concern.other=match?concern[match[0]]:/volt|outlet|gfci|electric/.test(text)?'Our residential plunge plugs into a standard 110-volt outlet. We provide a plug-in GFCI if your outlet doesn’t have one.':/temperature|cold|ice/.test(text)?'Our residential plunge cools down to 32°F and can make ice. You can choose your temperature as your preferences change.':/stair|deliver|carry/.test(text)?'Standard delivery is curbside. The residential model weighs 180 lbs empty. Use a flat furniture dolly on paved, level surfaces or carry it with straps. Carry it on stairs, never bump it along steps or use a hand-truck dolly. Call us for a white-glove delivery quote.':'Your question: “'+a.priority_other+'”. Call us for a specific answer from a real person in the U.S.';
    }
    summary.push([a.priority==='other'?'Your main concern':label('priority',a.priority),concern[a.priority]]);
    let installation;
    if(a.placement==='outdoor') {
      installation='Our plunge runs outdoors year-round without seasonal winterization.';
      if(a.cover!=='covered')installation+=' For your '+(a.cover==='partial'?'partially covered':'uncovered')+' spot, use an umbrella, awning, or privacy screen to block most direct sun. A couple of hours is fine; avoid prolonged direct sunlight.';
      else installation+=' Your covered location is ideal because it keeps it out of prolonged direct sunlight.';
    }else if(a.placement==='indoor'){
      installation=commercial?'At 28.5 inches wide, our commercial plunge fits through a standard doorway. The cooling system is built into the plunge, with no external chiller hoses.':'At 28.5 inches wide, our residential plunge fits through a standard doorway. It’s leak-free by design, with a seamless, one-piece internal liner and no holes in the tub.';
      if(!commercial&&a.priority==='leaks')installation='At 28.5 inches wide, our residential plunge fits through a standard doorway.';
    }else{
      installation=commercial?'Still choosing a location? Call our commercial team to discuss indoor and outdoor options.':'Still choosing a location? Our residential plunge works indoors or outdoors. It’s 28.5 inches wide and runs outdoors year-round without seasonal winterization.';
    }
    summary.push([a.placement==='outdoor'?'Outdoor use':a.placement==='indoor'?'Indoor use':'Where it can go',installation]);

    if(a.climate_cold||a.climate_hot){
      const weather='You selected a winter low of '+label('climate_cold',a.climate_cold||'unsure')+' and a summer high of '+label('climate_hot',a.climate_hot||'unsure')+'. ';
      const climateCopy=a.placement==='indoor'?'Your indoor placement keeps the plunge out of outdoor weather. '+weather+'If you move it outdoors later, it is designed for outdoor temperatures from -20°F to 120°F.':climateOutside?'Your climate falls outside our -20°F to 120°F outdoor operating range, so call us before ordering. '+weather+'We can discuss whether the location you have in mind is suitable.':a.climate_cold==='unsure'||a.climate_hot==='unsure'?'Our plunge is designed for outdoor temperatures from -20°F to 120°F, with no seasonal winterization. '+weather+'Confirm the seasonal extremes where it will be used before choosing an outdoor location.':'Your climate is within our -20°F to 120°F outdoor operating range, with no seasonal winterization. '+weather;
      summary.push(['Your climate',climateCopy]);
    }
    if(a.placement==='indoor'&&(a.stairs==='yes'||a.location==='basement'||a.location==='upper'))summary.push(['Delivery and stairs',(commercial?'The commercial model':'The residential model')+' weighs 180 lbs empty. Standard delivery is curbside. Call us for a white-glove delivery quote if you want help getting it into place. Use a flat furniture dolly on paved, level surfaces or carry it using straps. Carry it on stairs to avoid damage. Don’t use a hand-truck dolly, tip it onto its side, or bump it up or down steps.']);
    summary.push(['Body fit','Both residential and commercial models have internal dimensions of 54 inches long × 21 inches wide × 24 inches high. Maximum recommended user height: 6 feet 6 inches. Maximum recommended user weight: 280 lbs. These are recommended limits; body proportions and preferred posture affect comfort.']);
    summary.push(['Height fit',a.height==='over64'?'You selected over 6 feet 6 inches, above the maximum recommended height for either model. Contact our team before ordering to discuss fit.':a.height==='under52'?'You selected under 5 feet 2 inches. Contact our team before ordering to discuss a comfortable seated position.':'Your selected height is within the recommended height range.']);
    summary.push(['Weight fit',a.weight==='over250'?'Both models have a maximum recommended user weight of 280 lbs. You selected 250+ lbs, so call our team before ordering to make sure it’s a good fit for you. If you weigh more than 280 lbs, either model is outside our recommended weight limit.':'You selected '+label('weight',a.weight)+'. Both models have a maximum recommended user weight of 280 lbs, so your selected weight range is within the recommendation.']);
    summary.push(['Temperature',a.temperature==='unsure'?'Still deciding on your temperature? Our plunge goes all the way down to 32°F and can make ice. You can adjust the water temperature as your preferences change.':'You chose '+label('temperature',a.temperature)+'. Our plunge goes all the way down to 32°F and can make ice, so it can grow with you if you choose colder water over time.']);
    const power=commercial?'Call our commercial team to confirm the right power supply for your business.':'Our residential plunge plugs into a standard 110-volt outlet, draws only 2.36 amps and doesn’t need a dedicated circuit. We provide a plug-in GFCI that plugs right into your outlet.';
    summary.push(['Power',power]);
    if(a.priority!=='support')summary.push(['U.S.-based support',supportCopy]);
    if(a.priority!=='price')summary.push(['Budget',a.budget==='unsure'&&!commercial?'The residential model starts at $4,995. It includes built-in cooling down to 32°F, an ergonomic liner, a hard-top gasket-sealed lid, year-round outdoor use, and live U.S.-based phone support.':budgetCopy]);
    const conditional=commercial||(a.placement==='outdoor'&&a.cover!=='covered')||(a.placement==='indoor'&&(a.location==='basement'||a.location==='upper'||a.location==='other'||a.stairs==='yes'))||a.height!=='between'||a.weight==='over250'||climateOutside||a.budget==='unsure';
    return {status:low?'needs_review':conditional?'conditional':'strong',title:low||climateOutside||a.height==='over64'||a.weight==='over250'?'Fire Cold Plunge could potentially be a great fit!':'Based on your answers, Fire Cold Plunge is a great fit!',intro:'',conditions:[],summary,route:commercial?'commercial':'residential'};
  }
  return {questions,active,clean,label,assess};
})();
